__turbopack_context__.v({
  "DealDateCounter": "DealDateCounter-module-scss-module__gZNC-W__DealDateCounter",
});
